import { action } from '../../../appLogic/appActions';

export const APPLY_COUPON = action('APPLY_COUPON');
export const ADD_TO_CART = action('ADD_TO_CART');
export const REMOVE_ITEM = action('REMOVE_ITEM');
